/**
 * 申请分期记录
 */
import React from 'react';

import { Row, Col, DatePicker, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';

import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

class InstallmentApplyIndex extends React.Component {

    columns = [{
        title: '姓名',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '电话',
        dataIndex: 'tel',
        width: '10%',
    }, {
        title: '职业',
        dataIndex: 'profession',
        width: '10%',
    }, {
        title: '是否有社保',
        dataIndex: 'socialSecurity',
        width: '10%',
        format: {0:"否", 1: "是"}
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '10%',
    }, {
        title: '时间',
        dataIndex: 'insertTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/installmentLog/download',
            data: queryData,
            fileName: "申请分期记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/installmentLog/findApplyPage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default InstallmentApplyIndex;